import RunGroupTable from "@features/scenarioDesign/RunGroupTable"
import { useGetRunGroupsByBaseGraphQuery } from "@store/services/runService"
import { Box } from "@mui/material"
import { useEffect } from "react"
import { RunGroupStatus } from "@custom-types/modelRun"

export type ViewRunsModeProps = {
  baseGraphKey: string | undefined
  runGroupToHighlightKey: string | undefined
}

const ViewRunsMode = ({ baseGraphKey, runGroupToHighlightKey }: ViewRunsModeProps) => {
  const getRunGroupsQuery = useGetRunGroupsByBaseGraphQuery(baseGraphKey || "", {
    skip: !baseGraphKey,
  })
  const runGroups = getRunGroupsQuery.data?.items ?? []

  useEffect(() => {
    if (getRunGroupsQuery.isFetching || !getRunGroupsQuery.data) {
      return
    }

    const hasRunningGroups = runGroups.some(({ status }) => status === RunGroupStatus.RUNNING)
    if (!hasRunningGroups) {
      return
    }

    setTimeout(() => getRunGroupsQuery.refetch(), 5000)
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIX: deps after bulk migration
  }, [getRunGroupsQuery.isFetching])

  if (!baseGraphKey) {
    return
  }

  return (
    <Box>
      <RunGroupTable
        runGroups={runGroups}
        sessionStorageName="run-groups"
        runGroupToHighlightKey={runGroupToHighlightKey}
      />
    </Box>
  )
}

export default ViewRunsMode
